// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".root-container{min-width:280px;min-height:100vh;display:flex;flex-direction:column;justify-content:space-between;position:relative;transition:opacity .2s ease-in}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
